import st from "@/styles/UserSidebar.module.scss";
import {useAtom} from "jotai/index";
import {open_notifications_sidebar} from "@/atoms/profile.ts";
import clsx from "clsx";
import {useTranslation} from "react-i18next";
import CloseBtn from "@/ui/CloseButton.tsx";
import {CircularProgress} from "@mui/material";
import useNotifications from "@/hooks/notifications.ts";
import WarningCircleIcon from "@/svg/WarningCircleIcon.tsx";
import Button from "@/ui/Button.tsx";
import LoadIcon from "@/svg/LoadIcon.tsx";
import  {useState} from "react";
import {useNavigate} from "react-router-dom";
import DashboardClass from "@/utils/dashboard_class.ts";
import SystemNotificationComponent from "@/components/SystemNotificationComponent.tsx";


const SystemNotificationsSidebar = () => {
    
    const [openNotifSideMenu] = useAtom(open_notifications_sidebar)
    // const openNotifSideMenu = true
    const [loading_more, set_loading_more] = useState(false)
    const {t} = useTranslation()
    const notif = useNotifications()
    const paginated_notif = notif.getPgNotifications()
    const navigate = useNavigate()

    const on_more = async () => {
        
        set_loading_more(true)
        
        let timeout = setTimeout(async() => {
            await notif.updatePaginatedNotifications()
            set_loading_more(false)
            clearTimeout(timeout)
        }, 1000)
        
    }
    
    return (
        <div
            className={clsx(
                st.system_notifications,
                openNotifSideMenu && st.active
            )}
            onClick={() => {
                notif.notification_sidebar_handle()
            }}
        >
            
            <div
                onClick={(e) => {
                    e.stopPropagation()
                }}
                className={st.header}
            >
                <span>
                    {t("notifications")}
                </span>
                
                <CloseBtn
                    onClick={() => {
                        notif.notification_sidebar_handle()
                    }}
                    className={st.close_btn}
                />
                
            </div>
            
            
            <div
                onClick={(e) => {
                    e.stopPropagation()
                }}
                id={"notif_scrolling_elem"}
                className={st.fh_notif_container}
            >
                {typeof paginated_notif === "object" ? (
                    <>
                        {!paginated_notif.req_err ? (
                            <>
                                {paginated_notif.notif_list.length ? (
                                    <>
                                        {paginated_notif.notif_list.map((obj, i:number) => {
                                            
                                            const {type } = obj

                                            const kycTypes = [
                                                'expire_kyc_30_days',
                                                'expire_kyc_20_days',
                                                'expire_kyc_10_days',
                                                'expire_kyc_5_days',
                                                'expire_kyc_3_days',
                                                'expire_kyc_2_days',
                                                'expire_kyc_1_days',
                                            ];

                                            const on_click = () => {
                                                if(type === "loan_status_changed" && !obj.is_read) {
                                                    navigate(DashboardClass.dashboard_routes.PendingLoans)
                                                    notif.notification_sidebar_handle()
                                                }
                                                
                                                if(type === "contract_signed_successful" && !obj.is_read) {
                                                    navigate(DashboardClass.dashboard_routes.StandartCredit)
                                                    notif.notification_sidebar_handle()
                                                }
                                                
                                                if(type === "cr_line_application_status_changed" && !obj.is_read) {
                                                    navigate(DashboardClass.dashboard_routes.CreditLine)
                                                    notif.notification_sidebar_handle()
                                                }
                                                
                                                if(type === "added_attempt_doc_card" && !obj.is_read) {
                                                    navigate(DashboardClass.dashboard_routes.KYC)
                                                    notif.notification_sidebar_handle()
                                                }
                                                
                                                if(type === "added_attempt_liveness" && !obj.is_read) {
                                                    navigate(DashboardClass.dashboard_routes.KYC)
                                                    notif.notification_sidebar_handle()
                                                }
                                                
                                                if(type === "loan_data_changed" && !obj.is_read) {
                                                    navigate(DashboardClass.dashboard_routes.PendingLoans)
                                                    notif.notification_sidebar_handle()
                                                }
                                                
                                                if(type === "loan_status_changed_not_valid" && !obj.is_read) {
                                                    navigate(DashboardClass.dashboard_routes.PendingLoans)
                                                    notif.notification_sidebar_handle()
                                                }
                                            }

                                            return  (
                                                <SystemNotificationComponent
                                                    obj={obj}
                                                    on_click={on_click}
                                                    key={`notif_${i}`}
                                                    in_sidebar
                                                    kyc_check={kycTypes.includes(type)}
                                                />
                                            )
                                        })}
                                        
                                        <Button
                                            className={clsx( st.button_load, loading_more && st.loading)}
                                            outlined
                                            type={'button'}
                                            onClick={on_more}
                                            disabled={!paginated_notif?.has_more || loading_more}
                                        >
                                            <LoadIcon /> {t("load_more")}
                                        </Button>
                                    </>
                                    ) : (
                                    <strong> {t("no_notifs")} </strong>
                                )}
                            </>
                        ) : (
                            <div className={st.error}>
                                <WarningCircleIcon />
                                <strong>{t("notif_load_err")}</strong>
                            </div>
                        )}
                        
                    </>
                ) : (
                    <div className={st.circular_progress}>
                        <CircularProgress
                            size={60}
                            color={"success"}
                        />
                    </div>
                )}
            </div>
        
        </div>
    )
}

export default SystemNotificationsSidebar
